import { useEffect, useState } from "react";
import { db } from "../../firebase";
import { collection, query, where, getDocs } from "firebase/firestore";
import { buildOfferUrl } from "./shareLinks";
import { X } from "lucide-react";

export default function ShareCardModal({
  open,
  onClose,
  agentUid,
  currentCardId,
}) {
  const [cards, setCards] = useState([]);
  const [selected, setSelected] = useState(new Set());

  useEffect(() => {
    if (!open || !agentUid) return;
    (async () => {
      const qy = query(
        collection(db, "cards"),
        where("agentUid", "==", agentUid),
        where("status", "==", "active")
      );
      const snap = await getDocs(qy);
      const arr = [];
      snap.forEach((d) => arr.push({ id: d.id, ...d.data() }));
      setCards(arr);
      const preset = new Set();
      if (currentCardId) preset.add(currentCardId);
      setSelected(preset);
    })();
  }, [open, agentUid, currentCardId]);

  if (!open) return null;

  const toggle = (id) => {
    setSelected((s) => {
      const n = new Set(s);
      n.has(id) ? n.delete(id) : n.add(id);
      return n;
    });
  };

  const url = buildOfferUrl({ agentUid, cardIds: [...selected] });

  return (
    <div className="fixed inset-0 z-[100]">
      <div className="absolute inset-0 bg-black/60" onClick={onClose} />
      <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 w-[92vw] max-w-lg bg-slate-800 rounded-2xl p-5">
        <div className="flex items-center justify-between mb-3">
          <h3 className="text-lg font-bold">Share cards with players</h3>
          <button onClick={onClose} className="p-2 text-slate-300">
            <X size={20} />
          </button>
        </div>

        <div className="max-h-64 overflow-auto space-y-2 mb-3">
          {cards.map((c) => (
            <label
              key={c.id}
              className="flex items-center gap-3 p-2 rounded bg-slate-700"
            >
              <input
                type="checkbox"
                checked={selected.has(c.id)}
                onChange={() => toggle(c.id)}
              />
              <div className="flex-1">
                <div className="font-semibold">Card #{c.id.slice(0, 8)}…</div>
                <div className="text-xs text-slate-300">
                  {c.filled?.length || 0}/100 sold
                </div>
              </div>
            </label>
          ))}
          {!cards.length && (
            <div className="text-sm text-slate-300">No active cards.</div>
          )}
        </div>

        <div className="bg-slate-900 rounded-xl p-3 text-sm break-all">
          {url}
        </div>
        <div className="mt-3 flex gap-2">
          <button
            className="px-3 py-2 rounded-xl bg-lime-400 text-black font-semibold"
            onClick={() => navigator.clipboard.writeText(url)}
          >
            Copy Link
          </button>
          <button
            className="px-3 py-2 rounded-xl bg-slate-700"
            onClick={onClose}
          >
            Done
          </button>
        </div>
        <div className="text-xs text-slate-400 mt-2">
          Tip: select 1 card for single-card offer, or multiple for a bundle.
        </div>
      </div>
    </div>
  );
}
